import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as clevertapRegister from 'clevertap/register';
import { Trans } from '@lingui/macro';
import {
  verifyOtp,
  setUserForm,
  setOtpRegistration,
  otpError as setOtpError,
} from '../../state/register/actions';
import {
  resendVerificationEmail,
  generateOtpRequest,
} from '../../state/action-mess';
import { referralRequest, changeReferralData } from '../../state/auth/actions';
import styles from './style.css';
import ProfileSetupForm from './ProfileSetupForm';
import OtpInput from './OtpInput';

class Register extends React.Component {
  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = { showNotificationCookie: true };
  }

  componentWillMount() {
    const { ref } = this.props.location.query;
    const { referral } = this.props.data.auth;
    // if the new code is different from old referral in state
    if (ref && ref !== referral.code) {
      if (ref !== 'leads') {
        this.props.dispatch(referralRequest(ref));
      }
    } else {
      this.props.dispatch(changeReferralData({}));
    }
  }

  componentDidMount() {
    clevertapRegister.registrationStart({});
  }

  render() {
    const { dispatch, location, data } = this.props;
    const { ref } = location.query;
    const { currentlySending, error } = data.moka;
    const { referral } = data.auth;
    let phone = '';
    try {
      phone = data.registerForm.registrationForm.user.phone;
    } catch (error) {
      phone = '';
    }
    const { otpError } = data.registerForm;
    const { showOtpRegistration } = data.registerForm;
    return (
      <center className={`${styles['mk-register-bg-register']}`}>
        {!showOtpRegistration && (
          <div
            className={`${
              styles['mk-register-bg-box']
            } col-md-5 col-sm-12 col-xs-12`}
          >
            <div className={`${styles['mk-register-header']} row`}>
              <div
                className={`${styles['title-container']} text-center col-xs-12`}
              >
                <div className={`col-xs-12 ${styles['title-register']}`}>
                  <Trans>Start with MOKA now</Trans>
                </div>
                <div className={`col-xs-12 ${styles['subtitle-register']}`}>
                  <center>
                    <Trans>
                      Join more than 50.000 business owners in Indonesia and see
                      how Moka POS &#38; GoStore can help grow your business
                    </Trans>
                  </center>
                </div>
              </div>
            </div>
            <div className={`${styles.root} row`}>
              <ProfileSetupForm
                referral={referral.code}
                dispatch={dispatch}
                history={this.props.history}
                onSubmit={this.handleRegisterSubmit}
                pBusinessStarts={this.props.data.moka.businessStartsState}
                pBusinessSales={this.props.data.moka.businessSalesState}
                error={error}
                currentlySending={currentlySending}
                handleOnclickNotificationCookie={
                  this.handleOnclickNotificationCookie
                }
                showNotificationCookie={this.state.showNotificationCookie}
                showChapcha={this.props.params.chapcha}
              />
              {ref && referral.code && (
                <div className={`${styles['mk-referral-banner']}`}>
                  <div className="col-md-12">
                    <img
                      alt="Telkomsel"
                      className="img img-responsive"
                      src={referral.logo_url}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {showOtpRegistration && (
          <OtpInput
            timer={showOtpRegistration}
            phone={phone}
            dispatch={dispatch}
            otpError={otpError}
            setOtpError={setOtpError}
            showOtpAction={setOtpRegistration}
            handleResendOtp={this.handleResendOtp}
            handleBackClick={this.handleBackClick}
            handleOtpSubmit={this.handleOtpSubmit}
          />
        )}
      </center>
    );
  }

  handleResendOtp = phone => {
    const {
      user: { email },
    } = this.props.data.registerForm.registrationForm;
    clevertapRegister.clevertapTracker('OTP Resend', { email, phone });
    this.props.dispatch(generateOtpRequest({ phone }));
  };

  handleBackClick = () => {
    this.props.dispatch(setOtpError(null));
    const {
      user: { email, phone },
    } = this.props.data.registerForm.registrationForm;
    clevertapRegister.clevertapTracker('OTP Back', { email, phone });
    this.props.dispatch(setOtpRegistration(false));
  };

  handleOnclickNotificationCookie = () => {
    this.setState({ showNotificationCookie: false });
  };

  handleOtpSubmit = code => {
    const { request_id, registrationForm } = this.props.data.registerForm;
    const { isNativeApps } = this.props.location.query;
    const {
      businessTypesState,
      businessCategoriesAllState,
    } = this.props.data.moka;
    this.props.dispatch(
      verifyOtp({
        code,
        request_id,
        registrationForm,
        businessTypesState,
        businessCategoriesAllState,
        isNativeApps,
      })
    );
  };

  handleSubmitFromModal = values => {
    const { newEmailAddress, oldEmailAddress, captcha } = values;
    const { resetCaptcha } = this.props.data.registerForm;
    this.props.dispatch(
      resendVerificationEmail({
        oldEmail: oldEmailAddress,
        newEmail: newEmailAddress,
        captcha,
        resetCaptcha,
      })
    );
  };

  handleRegisterSubmit = values => {
    const {
      auth: {
        referral: { id },
      },
    } = this.props.data;
    let referralCode;
    if (values.referral) {
      referralCode = values.referral;
    } else {
      referralCode = id;
    }
    // HubSpot - Cookies
    let hsCookies = document.cookie.match(
      new RegExp('(^| )hubspotutk=([^;]+)')
    );
    if (!hsCookies) {
      hsCookies = ['', '', ''];
    }
    let sourceButtonName = document.cookie.match(
      new RegExp('(^| )sourceButtonName=([^;]+)')
    );
    if (!sourceButtonName) {
      sourceButtonName = ['', '', ''];
    }
    const phoneNumber = `+62${values.userPhone}`;
    const formValue = {
      user: {
        email: values.emailAddress.trim(),
        full_name: values.userFirstName.trim(),
        password: values.password,
        password_confirmation: values.password,
        phone: phoneNumber,
      },
      referral_code: referralCode,
      agent: 'browser',
      captcha: values.captcha,
      hubspot: hsCookies[2],
      sourceButtonName: sourceButtonName[2],
      channel: 'WEB',
    };
    this.props.dispatch(setUserForm(formValue));
  };
}

Register.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  dispatch: PropTypes.func,
  location: PropTypes.object,
};

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(Register);
